// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"892":"167156a5","931":"13fd5050"}[chunkId] + ".chunk.css";
};